import React, {Fragment, Suspense} from 'react';

const Activity = props => {
    return (
        <Fragment>
            <div>
                Activity Coming Soon...!
            </div>
        </Fragment>
    )
}

export default Activity;
